
import 'reflect-metadata';
import { Options, Vue, Prop } from 'vue-property-decorator';


@Options({})
export default class Loader extends Vue {
  @Prop({ default: false }) isNoConnection!: boolean;
}
